export const MAINTENANCE_SCHEDULES = "maintenance_schedules";
export const STATUS_PAGE_DEFAULT_STATUS_DATE_RANGE = "status_page_default_status_date_range";
export const CHECKS_LIST_CUSTOM_VIEWS = "checks_list_custom_views";
export const ANALYZER = "analyzer";
export const ANALYZER_DEBUG = "analyzer_debug";
export const STATUS_PAGE_LAYOUT_DISPLAY = "status_page_layout_display";
export const STATUS_PAGE_BRAND_AUTOFILL = "status_page_brand_autofill";
export const GLOBALPING_NETWORK_CHECK = "globalping_network_check";
export const FEATUREBASE_JWT = "featurebase_jwt";
export const REQUEST_DEMO = "request_demo";
export const SERVICENOW = "servicenow";
export const METRICS_EXPLORER = "metrics_explorer";
export const WHATSAPP = "whatsapp";
export const WHATSAPP_CONTACT = "whatsapp_contact";
